/**
 * Entrance-animation props for quiz screens (framer-motion). Headless screenshot
 * harnesses set `window.__QUIZ_NO_MOTION__ = true` to render the final frame
 * immediately — under Chrome's --virtual-time-budget the animation can freeze
 * mid-flight and capture a blank screen.
 */
declare global {
  interface Window {
    __QUIZ_NO_MOTION__?: boolean;
  }
}

export function quizEntrance() {
  if (typeof window !== "undefined" && window.__QUIZ_NO_MOTION__) {
    return { initial: false as const };
  }
  return {
    initial: { opacity: 0, y: 14 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.3 },
  };
}
